import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useXMLViewerContext } from '../../context/xml-viewer-context';
export function Attributes(props) {
    const { attributes } = props;
    const { theme } = useXMLViewerContext();
    if (!attributes) {
        return null;
    }
    return (_jsx("span", { children: Object.entries(attributes).map(([key, value]) => (_jsxs("span", { children: [_jsx("span", { style: { color: theme.attributeKeyColor }, children: ` ${key}` }), _jsx("span", { style: { color: theme.separatorColor }, children: "=" }), _jsx("span", { style: { color: theme.attributeValueColor }, children: `"${value}"` })] }, `attribute-${key}`))) }));
}
//# sourceMappingURL=index.js.map